<div class="flex justify-center items-center h-[100vh]">
  <h1 class="text-[50px]">{{ "notFound.content" | translate }}</h1>
</div>
